if($('#user_profile_settings').length) {
    // $("#telephone_number").inputmask("mask", {"mask": "+99 999-999-999"});
    // $("#postal_code").inputmask("mask", {"mask": "99-999"});
    // $("#vat_id").inputmask("mask", {"mask": "PL9999999999"});
}
